const FAR_FUTURE_TIME = Number.MAX_SAFE_INTEGER;
export default FAR_FUTURE_TIME;
//# sourceMappingURL=FarFutureTime.js.map